module.exports = __webpack_public_path__ + "img/KJF-TagHollen.63f4761e.jpg";